// extracted by mini-css-extract-plugin
export default {"child":"_child_T++xHB","trash":"_trash_wb+D+r"};